import { atom } from 'recoil';

// show archived customers
export const customersArchiveAtom = atom<boolean>({
   key: 'customerArchiveFilter',
   default: false,
});
